// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"K_cT","accordionItem":"K_cT","open":"K_cV","icon":"K_cc","toogler":"K_cW","title":"K_bx","content":"K_b","content-body":"K_cX","contentBody":"K_cX","text":"K_cn"};